module.exports = __webpack_public_path__ + "static/media/display-4.a03055c9.png";